import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Composants graphiques utilises
import { BootstrapPopupModule } from '../../../shared/bootstrap-popup/bootstrap-popup.module';
import { JobsModule } from '../../../technical-modules/jobs/jobs.module';
import { PannelModule } from '../../../shared/pannel/pannel.module';

// Module metier utilises
import { AgenceModule } from '../../structure/agence/agence.module';
import { AntenneModule } from '../../structure/antenne/antenne.module';
import { ArretSlbModule } from '../arret-slb/arret-slb.module';
import { GroupementParcModule } from '../../structure/groupement-parc/groupement-parc.module';
import { IntervenantModule } from '../../humain/intervenant/intervenant.module';
import { OuvrageModule } from '../../structure/ouvrage/ouvrage.module';
import { ParcModule } from '../../structure/parc/parc.module';
import { MemoModule } from '../../memo/memo.module';
import { TypeMainenanceModule } from '../../planification-maintenance/type-maintenance/type-maintenance.module';

// Modules communs utilises
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module'
import { JSR310LocalDatesModule } from '../../../shared/jsr310-localdates/jsr310-localdates.module';
import { SuggestableInputModule } from '../../../shared/suggestable-input/suggestable-input.module';
import { StaticTypesModule } from '../../../static-types/static-types.module';

// Modules Material utilises
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';

// Autres modules externes utilises 

// Composants metiers
import { AccesDetailsComponent } from './components/acces-details.component';
import { AccesFermetureComponent } from './components/acces-fermeture.component';
import { AccesAssociationArretsComponent } from './components/acces-association-arrets.component';
import { AccesAssociationArretsDialogComponent } from './components/acces-association-arrets-dialog.component';
import { AccesAssociationOperationsDialogComponent } from './components/acces-association-operations-dialog.component';
import { AccesOperationBinderComponent } from './components/acces-operation-binder.component';
import { AccesRefusComponent } from './components/acces-refus.component';
import { AccesWidgetComponent } from './components/acces-widget.component';
import { AccesSearchFiltersComponent } from './components/acces-search-filters.component';
import { AccesListeComponent } from './components/acces-liste.component';
import { AccesTarifNegatifComponent } from './components/acces-liste-tarif-negatif.component';
import { CoactiviteSolaireCheckerComponent } from './components/coactivite-solaire-checker.component';
import { CoactiviteEolienCheckerComponent } from './components/coactivite-eolien-checker.component';
import { EditAccesComponent } from './components/edit-acces.component';
import { EditAccesConduiteComponent } from './components/edit-acces-conduite.component';
import { ButtonEditAccesConduiteComponent } from './components/btn-edit-acces-conduite.component';
import { GestionAccesComponent } from './components/gestion-acces.component';
import { GestionAccesTarifNegatifComponent } from './components/gestion-acces-tarif-negatif.component';
import { ModificationTarifNegatifComponent } from './components/modification-tarif-negatif.component';
import { PlanificationTarifNegatifComponent } from './components/planification-tarif-negatif.component';
import { RappelIntervenantsComponent } from './components/rappel-intervenants.component';
import { EtatOuvrageComponent } from './components/etat-ouvrage.component';
import { NotificationFermetureAccesComponent } from './components/notif-fermeture-acces.component';
import { ControleSecuriteDialogComponent } from './components/controle-securite-dialog.component';

// Services metier
import { AccesService } from './services/acces.service';
import { MotifRefusService } from './services/motif-refus.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

// Directives
import { ClickStopPropagation } from '../../../shared/directives/click-stop-propation';
import { FormattersModule } from '../../../ui-modules/formatters/formatters.module';
import { FiltersModule } from '../../../ui-modules/filters/filters.module';

import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';


@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
	
		BootstrapPopupModule,
		JobsModule,
		PannelModule,
	
		MatPaginatorModule,
		MatProgressBarModule,
		MatTableModule,
		MatSortModule,
		MatTooltipModule,
		
		JSR310LocalDatesModule,
		
		AgenceModule,
		AntenneModule,
		ArretSlbModule,
		GroupementParcModule,
		IntervenantModule,
		OuvrageModule,
		ParcModule,
		MemoModule,
		TypeMainenanceModule,
		
		FilterableSelectModule,
		FormattersModule,
		StaticTypesModule,
		SuggestableInputModule,
		CheckboxListModule,
		FiltersModule
	],
	providers: [
		AccesService,
		MotifRefusService,
	],
	declarations: [
		AccesDetailsComponent,
		AccesFermetureComponent,
		AccesAssociationArretsComponent,
		AccesAssociationArretsDialogComponent,
		AccesAssociationOperationsDialogComponent,
		AccesOperationBinderComponent,
		AccesRefusComponent,
		AccesWidgetComponent,
		AccesSearchFiltersComponent,
		AccesListeComponent,
		AccesTarifNegatifComponent,
		CoactiviteSolaireCheckerComponent,
		CoactiviteEolienCheckerComponent,
		EditAccesComponent,
		EditAccesConduiteComponent,
		ButtonEditAccesConduiteComponent,
		GestionAccesComponent,
		GestionAccesTarifNegatifComponent,
		ModificationTarifNegatifComponent,
		PlanificationTarifNegatifComponent,
		RappelIntervenantsComponent,
		EtatOuvrageComponent,
		ClickStopPropagation,
		NotificationFermetureAccesComponent,
		ControleSecuriteDialogComponent
	],
	exports: [
		AccesOperationBinderComponent,
		AccesWidgetComponent,
		AccesSearchFiltersComponent,
		AccesListeComponent,
		AccesTarifNegatifComponent,
		EditAccesConduiteComponent,
		CoactiviteSolaireCheckerComponent,
		CoactiviteEolienCheckerComponent,
		GestionAccesComponent,
		GestionAccesTarifNegatifComponent,
	]
})
export class AccesModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('accesDetails',
		downgradeComponent({ component: AccesDetailsComponent })
	) //
	.directive('accesFermeture',
		downgradeComponent({ component: AccesFermetureComponent })
	) //
	.directive('accesAssociationArretsDialog',
		downgradeComponent({ component: AccesAssociationArretsDialogComponent })
	) //
	.directive('accesRefusComponent',
		downgradeComponent({ component: AccesRefusComponent })
	) //
	.directive('accesOperationBinder',
		downgradeComponent({ component: AccesOperationBinderComponent })
	) //
	.directive('accesWidget',
		downgradeComponent({ component: AccesWidgetComponent })
	) //
	.directive('coactiviteSolaireChecker',
		downgradeComponent({ component: CoactiviteSolaireCheckerComponent })
	) //
	.directive('coactiviteEolienChecker',
		downgradeComponent({ component: CoactiviteEolienCheckerComponent })
	) //
	.directive('editAcces',
		downgradeComponent({ component: EditAccesComponent })
	) //
	.directive('accesAssociationOperationsDialog',
		downgradeComponent({ component: AccesAssociationOperationsDialogComponent })
	) //
	.directive('btnEditAccesConduite',
		downgradeComponent({ component: ButtonEditAccesConduiteComponent })
	) //
	.directive('editAccesConduite',
		downgradeComponent({ component: EditAccesConduiteComponent })
	) //
	.directive('notifFermetureAcces',
		downgradeComponent({ component: NotificationFermetureAccesComponent })
	) //
;